<template>
  <b-modal
      ref="show-notification-modal"
      :title="$t('notification.details.modal')"
      :cancel-title="$t('btn.close')"
      ok-only
      size="lg"
  >
    <div v-if="notification" class="question-details">
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('notification.details.id') }}</th>
              <td>{{ notification.id }}</td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.name') }}</th>
              <td>{{ notification.name }}</td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.content') }}</th>
              <td v-html="notification.content"></td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.createdAt') }}</th>
              <td>{{ notification.createdAt | dateTime24HoursFormat }}</td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.isApprovalRequired') }}</th>
              <td>{{ notification.isApprovalRequired }}</td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.segments') }}</th>
              <td>
                <div v-for="segment in notification.segments" :key="segment.id">
                  {{ segment.name }}
                </div>
              </td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.status') }}</th>
              <td>
                <b-badge pill variant="primary" v-if="notification.status === 'draft'">{{ $t('notification_status_' + notification.status ) }}</b-badge>
                <b-badge pill variant="success" v-if="notification.status === 'active'">{{ $t('notification_status_' + notification.status ) }}</b-badge>
              </td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.displayDateFrom') }}</th>
              <td>{{ notification.displayDateFrom | dateTime24HoursFormat }}</td>
            </tr>
            <tr>
              <th>{{ $t('notification.details.displayDateTo') }}</th>
              <td>{{ notification.displayDateTo | dateTime24HoursFormat }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// import moment from 'moment';

export default {
  data() {
    return {
      notification: null
    }
  },
  filters: {},
  mounted() {

  },
  methods: {
    openModal(notification) {
      this.notification = notification;
      this.$refs['show-notification-modal'].show();
    }
  }
}
</script>
